import React from 'react';
import { Badge } from '@one-thd/sui-atomic-components';

export type StatusTone = 'success' | 'info' | 'warning' | 'neutral';

// Badge has no 'neutral' color of its own — 'medium' is its closest equivalent (a grey/subtle
// treatment), matching this component's previous sui-bg-strong/sui-text-primary neutral tone.
const TONE_TO_BADGE_COLOR: Record<StatusTone, 'success' | 'info' | 'warning' | 'medium'> = {
  success: 'success',
  info: 'info',
  warning: 'warning',
  neutral: 'medium'
};

export interface StatusBadgeProps {
  label: string;
  tone?: StatusTone;
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({ label, tone = 'neutral' }) => (
  <Badge variant="regular" color={TONE_TO_BADGE_COLOR[tone]}>
    {label}
  </Badge>
);
